import React from "react";
import { Button } from "react-bootstrap";
import type { DashboardWidget } from "../../../types/dashboard/dashboard.types";
import { useTranslate } from "../../../hooks/LanguageProvider";

type Props = {
  widget: DashboardWidget;
  onRequestDelete: (widget: DashboardWidget) => void;
  isEditMode: boolean;
  children: React.ReactNode;
};

export default function WidgetShell({
  widget,
  onRequestDelete,
  isEditMode,
  children,
}: Props) {
  const { translate } = useTranslate();

  return (
    <div className="widget-container">
      {/* ✅ Header UNIQUEMENT pour le bouton supprimer */}
      {isEditMode && (
        <div className="widget-header d-flex justify-content-end align-items-center">
          <Button
            size="sm"
            variant="link"
            className="text-danger p-0"
            title={translate("Delete widget")}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onRequestDelete(widget);
            }}
          >
            <i className="ri-close-line" style={{ fontSize: 20 }}></i>
          </Button>
        </div>
      )}

      <div className="widget-body">{children}</div>
    </div>
  );
}
